const services = [
  {
    icon: 'ri-camera-line',
    title: 'CFTV & Monitoramento',
    description:
      'Instalação e manutenção de circuitos fechados de TV com câmeras IP de alta definição, gravadores digitais e monitoramento remoto 24h.',
    items: ['Câmeras IP & Analógicas HD', 'DVR/NVR Profissional', 'Monitoramento Remoto 24h', 'Análise de Imagem com IA'],
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Controle de Acesso',
    description:
      'Sistemas inteligentes de controle de entrada e saída, com biometria, cartão de proximidade e integração com outros sistemas.',
    items: ['Biometria Digital & Facial', 'Cartão de Proximidade', 'Catracas e Barreiras', 'Integração com RH'],
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Sistemas de Alarme',
    description:
      'Central de alarme com sensores de presença, vibração e fumaça, integrados a uma central de monitoramento profissional.',
    items: ['Sensores de Presença', 'Detector de Fumaça & Gas', 'Central de Alarme', 'Notificação Imediata'],
  },
  {
    icon: 'ri-wifi-line',
    title: 'Redes & Infraestrutura',
    description:
      'Implantação de redes cabeadas e wireless de alta performance para suporte dos sistemas de segurança e operação corporativa.',
    items: ['Redes Corporativas', 'Wi-Fi Empresarial', 'Cabeamento Estruturado', 'Fibra Óptica'],
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Manutenção Preventiva',
    description:
      'Programa estruturado de manutenção preventiva e corretiva para garantir o pleno funcionamento dos sistemas críticos.',
    items: ['Visitas Técnicas Periódicas', 'Relatórios Detalhados', 'Reposição de Peças', 'Atendimento Prioritário'],
  },
  {
    icon: 'ri-links-line',
    title: 'Integração de Sistemas',
    description:
      'Integração de hardware e software de diferentes fabricantes em uma plataforma unificada de gerenciamento e controle.',
    items: ['Plataformas Unificadas', 'APIs e Integrações', 'Gestão Centralizada', 'Suporte Especializado'],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <span className="inline-block text-red-500 text-xs font-bold uppercase tracking-widest bg-red-500/10 border border-red-500/20 px-3 py-1.5 rounded-full mb-6">
            / Nossas Soluções
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Serviços Integrados de{' '}
            <span className="text-red-500">Segurança Eletrônica</span>
          </h2>
          <p className="text-neutral-400 text-base leading-relaxed">
            Do planejamento à implantação e manutenção contínua — soluções completas com foco total em resultados para o seu negócio.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-neutral-900 border border-neutral-800 rounded-2xl p-7 hover:border-red-800/80 group transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-600/10 border border-red-600/20 rounded-xl mb-6 group-hover:bg-red-600/20 transition-colors">
                <i className={`${service.icon} text-red-500 text-2xl`}></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {service.title}
              </h3>
              <p className="text-neutral-400 text-sm leading-relaxed mb-5">{service.description}</p>
              <ul className="space-y-2.5">
                {service.items.map((item) => (
                  <li key={item} className="flex items-center gap-2.5 text-neutral-500 text-sm">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-red-600 text-sm"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
